import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getKbIds = createAsyncThunk('kbIds/get', API.kbIds.get);

export const updateKbId = createAsyncThunk(
  'kbIds/update',
  async ({ id, kbId }: { id: string; kbId: string }) => API.kbIds.update({ id, kbId }),
);
